module.exports = [
  require('./bellNumbers'),
  require('./composition'),
  require('./stirlingS2'),
  require('./catalan')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/function/combinatorics/index.js
// module id = 1038
// module chunks = 0